import { useState, useEffect, useMemo } from 'react';
import { useRoleMenu } from './useRoles';

/**
 * Custom hook to get tasks for a specific role
 *
 * @param {string} roleKey - The role key to get tasks for
 * @returns {Object} - { tasks, loading, error, refetch }
 */
export const useTasks = (roleKey) => {
  const { roleMenu, loading, error, refetch } = useRoleMenu(roleKey);

  const tasks = useMemo(() => {
    if (!roleMenu || !roleMenu.tasks) {
      return [];
    }
    return roleMenu.tasks;
  }, [roleMenu]);

  return {
    tasks,
    loading,
    error,
    refetch,
  };
};

/**
 * Custom hook to get a specific task by task key from a role
 *
 * @param {string} roleKey - The role key
 * @param {string} taskKey - The task key to find
 * @returns {Object} - { task, loading, error, refetch }
 */
export const useTask = (roleKey, taskKey) => {
  const { tasks, loading, error, refetch } = useTasks(roleKey);

  const task = useMemo(() => {
    if (!tasks || !taskKey) {
      return null;
    }
    return tasks.find(t => t.task === taskKey);
  }, [tasks, taskKey]);

  return {
    task,
    loading,
    error,
    refetch,
  };
};
